/**
 * 문자열이 이메일 포맷에 적합한지 검증하는 함수
 * @returns boolean, (true: 이메일 포맷에 적합, false: 이메일 포맷에 적합하지 않음)
 */

const validateEmailFormat = (str: string) => {
  const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  return regex.test(str);
};

export default validateEmailFormat;
